<div class="summary-container">
  <div class="summary-detail" *ngFor="let item of summaryItems; trackBy: trackByIndex">
    <div class="summary-key bold">{{item.key}}</div>
    <div class="summary-value" *ngIf="item.hasUrl"><a [routerLink]="item.url">{{item.value}}</a></div>
    <div title='{{getTitleForLongText(item.value)}}' class="summary-value" *ngIf="!item.hasUrl">{{item.value}}</div> 
  </div>  
</div>

